import React, { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { FeaturesEnums } from 'src/shared/enums';
import { useFeatures } from 'src/shared/hooks';

interface Props {
  features: FeaturesEnums | FeaturesEnums[] | undefined; // if undefined, hook will return false
  children: ReactNode;
  redirectTo?: string;
  strict?: boolean;
}

export const ComponentWithFeatures: FC<Props> = ({ children, features = [], redirectTo, strict }) => {
  const hasFeatures = useFeatures(features, strict);

  if (!hasFeatures) {
    if (redirectTo) {
      return <Navigate to={redirectTo} />;
    }

    return null;
  }

  return <>{children}</>;
};
